import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from "@angular/router";
import * as jQuery from "jquery";

@Component({
  selector: 'lk-frame',
  templateUrl: './frame.component.html',
  styleUrls: ['./frame.component.scss']
})
export class FrameComponent implements OnInit {
  private themes;

  constructor( private route: ActivatedRoute ) { }

  ngOnInit() {
    this.route.data
      .map( data => {
        return {
          themes: data.data[3].map(cover => { return { id: cover.id, theme: JSON.parse(cover.theme_data) };})
        };
      })
      .subscribe(
        ( data ) => {
          this.themes = data.themes.filter( theme => theme.theme && theme.theme.css );
          if( this.themes.length > 0 )
            this.changeStyles(this.themes[0].theme.css);
        }
      );

    this.route
      .queryParams
      .subscribe(
        data => {
          if(data.theme){
            const theme = this.themes.find(theme => theme.id == data.theme );
            if(theme && theme.theme && theme.theme.css)
              this.changeStyles(theme.theme.css);
          }
        }
      )
  }

  private changeStyles(styleObj){
    jQuery('style#lk-styles').remove();
    jQuery('head').append('<style id="lk-styles">' + styleObj + '</style>');
  }

}



// WEBPACK FOOTER //
// ./src/app/components/frame/frame.component.ts